import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Facebook } from 'lucide-react';
import { useState } from 'react';
import { churchInfo } from '../mock';

const LOGO_URL = "/images/seal.png";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Ministries', path: '/ministries' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-md sticky top-0 z-50 border-b-4 border-yellow-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img src={LOGO_URL} alt="True Love M.B.C." className="h-12 w-12 rounded-full object-cover group-hover:shadow-lg transition-shadow duration-300" />
            <div className="hidden md:block">
              <h1 className="text-3xl font-bold text-blue-800">{churchInfo.name}</h1>
              <p className="text-lg text-yellow-600 font-semibold">{churchInfo.tagline}</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-lg font-semibold transition-colors duration-200 relative group ${
                  isActive(link.path) ? 'text-blue-600' : 'text-blue-700 hover:text-blue-600'
                }`}
              >
                {link.name}
                <span
                  className={`absolute bottom-0 left-0 w-full h-0.5 bg-yellow-500 transform transition-transform duration-200 ${
                    isActive(link.path) ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                  }`}
                />
              </Link>
            ))}
            <a
              href={churchInfo.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-semibold"
            >
              <Facebook className="h-4 w-4" />
              <span className="text-sm">Follow Us</span>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-blue-50 transition-colors duration-200"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="h-6 w-6 text-blue-700" /> : <Menu className="h-6 w-6 text-blue-700" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-yellow-300">
            <nav className="flex flex-col space-y-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-2 rounded-lg transition-colors duration-200 ${
                    isActive(link.path)
                      ? 'bg-blue-100 text-blue-700 font-bold'
                      : 'text-blue-700 hover:bg-blue-50'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href={churchInfo.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200"
              >
                <Facebook className="h-4 w-4" />
                <span className="text-sm font-medium">Follow Us on Facebook</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};